export const insert = async (key, data, time = 5000) => {
  const localStorageKey = 'pae-' + key
  const expires = new Date().getTime() + time
  const parsed = JSON.stringify({
    data: data,
    expires
  })
  localStorage.setItem(localStorageKey, parsed)
}

export const get = async (key) => {
  const localStorageKey = 'pae-' + key
  if (localStorage.getItem(localStorageKey)) {
    try {
      var now = new Date().getTime()
      const data = JSON.parse(localStorage.getItem(localStorageKey))
      if (now < data.expires) {
        return data.data
      }

      localStorage.removeItem(localStorageKey)
      return null
    } catch (e) {
      localStorage.removeItem(localStorageKey)
      return null
    }
  }
}

export const remove = async (key) => {
  const localStorageKey = 'pae-' + key
  localStorage.removeItem(localStorageKey)
}

export const expires = async () => {
  const toRemove = []
  const currentDate = new Date().getTime()
  const initialKey = 'pae-'
  const localStorageLength = localStorage.length
  for (let index = 0; index < localStorageLength; index++) {
    const key = localStorage.key(index)
    if (key.includes(initialKey)) {
      const itemValue = localStorage.getItem(key)
      if (itemValue && /^\{(.*?)\}$/.test(itemValue)) {
        const current = JSON.parse(itemValue)
        if (current.expires && current.expires <= currentDate) {
          toRemove.push(key)
        }
      }
    }
  }

  for (let index = 0; index < toRemove.length; index++) {
    localStorage.removeItem(toRemove[index])
  }
}

export const updateExpires = async (key, time = 5000) => {
  const expires = new Date().getTime() + time
  const value = await get(key)
  if (value) {
    await remove(key)
    await insert(key, value, expires)
  }
}
